import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class RestringirMccClienteService {

  constructor(private http:HttpClient, private httpService:HttpService) { }

  buscaRestricoes(data: any, successHandle: Function, errorHandle: Function) {
    this.httpService.doGet('/mcc/customerRestrictions',data, successHandle, errorHandle);
  }

  buscaProdutos() {
    return this.http.get(API + '/enterprise/activeProductList');
  }

  salvaRestricoes(data: any, successHandle: Function, errorHandle: Function) {
    this.httpService.doPost('/mcc/lockCustomer',data, successHandle, errorHandle);
  }

}
